import LOCALES from 'constants/locales';

export const langTexts = [
  { key: LOCALES.ENGLISH_US, shortText: 'EN', longText: 'English' },
  {
    key: LOCALES.SPANISH_LATAM,
    shortText: 'ES',
    longText: 'Español (Latin America)'
  },
  { key: LOCALES.SPANISH_ES, shortText: 'ES', longText: 'Español (España)' },
  {
    key: LOCALES.PORTUGUESE_BR,
    shortText: 'PT',
    longText: 'Português (Brasil)'
  },
  {
    key: LOCALES.PORTUGUESE_PT,
    shortText: 'PT',
    longText: 'Português (Portugal)'
  },
  { key: LOCALES.FRENCH_FR, shortText: 'FR', longText: 'Français' },
  { key: LOCALES.RUSSIAN_RU, shortText: 'RU', longText: 'Русский' },
  { key: LOCALES.GERMAN_DE, shortText: 'DE', longText: 'Deutsch' },
  { key: LOCALES.ITALIAN_IT, shortText: 'IT', longText: 'Italiano' },
  { key: LOCALES.HINDI_IN, shortText: 'HI', longText: 'हिन्दी' },
  { key: LOCALES.UKRAINIAN, shortText: 'UA', longText: 'Українська' },
  { key: LOCALES.TURKISH_TR, shortText: 'TR', longText: 'Türkçe' },
  { key: LOCALES.ROMANIAN_RO, shortText: 'RO', longText: 'Română' },
  { key: LOCALES.AZERBAIJANI_AZ, shortText: 'AZ', longText: 'Azərbaycan' }
];
